import Cookies from 'js-cookie'
import { UserStatus } from '../../types/UserStatus.enum'

const AUTH_STATE_COOKIE_NAME = 'lastAmpAuthState'
const LOGIN_STATUS_COOKIE_NAME = 'amp-wls'

export function setLocalUserStatus(status: UserStatus) {
  const domain = window?.location?.hostname?.endsWith('.ameriprise.com')
    ? 'ameriprise.com'
    : undefined

  let cookieValue: string
  switch (status) {
    case UserStatus.PROSPECT:
      cookieValue = 'unrecognized'
      break
    case UserStatus.CLIENT_ACTIVE:
      cookieValue = 'active'
      break
    case UserStatus.CLIENT_EXPIRED:
      cookieValue = 'expired'
      break
    default:
      cookieValue = 'unrecognized'
  }

  Cookies.set(AUTH_STATE_COOKIE_NAME, cookieValue, {
    path: '/',
    expires: 365,
    domain: domain
  })
}

export function getLocalUserStatus(): UserStatus {
  const cookieValue = Cookies.get(AUTH_STATE_COOKIE_NAME)
  if (cookieValue === 'active') {
    // check login status cookie to differentiate between active and expired
    const loginStatus = Cookies.get(LOGIN_STATUS_COOKIE_NAME)
    if (!loginStatus || loginStatus !== 'true') {
      setLocalUserStatus(UserStatus.CLIENT_EXPIRED)
      return UserStatus.CLIENT_EXPIRED
    }
    return UserStatus.CLIENT_ACTIVE
  }

  if (cookieValue === 'expired') return UserStatus.CLIENT_EXPIRED
  if (cookieValue === 'unrecognized') return UserStatus.PROSPECT

  // If cookie is missing or unexpected, set to 'unrecognized' and return PROSPECT
  setLocalUserStatus(UserStatus.PROSPECT)
  return UserStatus.PROSPECT
}
